var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12901",
    "data-name": "Group 12901",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2446",
    "data-name": "Rectangle 2446",
    width: 32,
    height: 32,
    fill: "#600097"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12900",
    "data-name": "Group 12900",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12898",
    "data-name": "Path 12898",
    d: "M0,59.567C.111,59.04.178,58.5.339,57.99a7.373,7.373,0,0,1,3.511-4.328c.063-.036.123-.076.163-.1-.34-.379-.71-.732-1.01-1.137a5.194,5.194,0,0,1,3.473-8.178,5.126,5.126,0,0,1,3.5.742,1.331,1.331,0,0,0,.662.193c2.521.013,5.041.008,7.562.008h.374a6.019,6.019,0,0,1,3.021-5.252,4.456,4.456,0,0,1-1.454-4.007A4.292,4.292,0,0,1,21.7,33.167a4.456,4.456,0,0,1,5.929.218A4.512,4.512,0,0,1,27.5,39.95a6.016,6.016,0,0,1,3,5.243c.21,0,.4-.008.58,0a.938.938,0,0,1,.918.921c0,.083,0,.167,0,.25q0,6.3,0,12.593c0,.073,0,.146,0,.219a.935.935,0,1,1-1.87.01c-.012-.342,0-.684,0-1.047H14.677c.069.431.165.856.2,1.286.045.57.056,1.144.054,1.716a.928.928,0,0,1-.982.984q-6.484.006-12.968,0A1.068,1.068,0,0,1,0,61.442V59.567m30.1-3.323V47.079H11.9a5.3,5.3,0,0,1-1.323,6.311c.1.056.186.107.275.153a7.257,7.257,0,0,1,2.756,2.431.558.558,0,0,0,.532.275q7.808-.01,15.617-.005Zm-17.066,4a5.455,5.455,0,0,0-2.855-4.922,5.344,5.344,0,0,0-5.847.259,5.448,5.448,0,0,0-2.462,4.663ZM7.214,52.719a3.326,3.326,0,1,0-3.333-3.341,3.348,3.348,0,0,0,3.333,3.341m13.259-7.547H28.6a4.064,4.064,0,1,0-8.127,0m4.2-6.024a2.566,2.566,0,0,0-.24-5.126,2.566,2.566,0,1,0,.24,5.126",
    transform: "translate(0 -30.13)",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12899",
    "data-name": "Path 12899",
    d: "M12.938,0A8.485,8.485,0,0,1,14.444.63,3.276,3.276,0,0,1,15.934,3.5c.009,1.468,0,2.937.009,4.405a1.017,1.017,0,0,0,.155.515c.519.8,1.054,1.6,1.59,2.392a1,1,0,0,1,.135,1.11,1.017,1.017,0,0,1-1,.5q-6.624,0-13.247,0A3.423,3.423,0,0,1,.049,9.512.267.267,0,0,0,0,9.436V3A1.265,1.265,0,0,0,.06,2.828,3.287,3.287,0,0,1,1.732.472,8.7,8.7,0,0,1,3,0Zm2.317,10.548c-.315-.473-.575-.886-.859-1.281a1.775,1.775,0,0,1-.341-1.106c.016-1.52.008-3.04.006-4.559a1.589,1.589,0,0,0-1.733-1.726q-4.356,0-8.713,0A1.592,1.592,0,0,0,1.876,3.626q0,2.529,0,5.059a1.629,1.629,0,0,0,1.851,1.862H15.255Z",
    transform: "translate(-0.001 0.001)",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12900",
    "data-name": "Path 12900",
    d: "M68.066,57.875c-1,0-2,.009-3,0a.922.922,0,0,1-.883-1.276.954.954,0,0,1,.972-.6h3.434c.812,0,1.624-.01,2.435,0a.935.935,0,1,1,0,1.869c-.989.006-1.977,0-2.966,0",
    transform: "translate(-60.098 -52.49)",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12901",
    "data-name": "Path 12901",
    d: "M66.571,114.034c-.541,0-1.082.023-1.621-.007a.885.885,0,0,1-.807-.819.925.925,0,0,1,.6-.959,1.34,1.34,0,0,1,.428-.07c.947-.006,1.893-.011,2.84,0a.925.925,0,0,1,1,.858.914.914,0,0,1-.848,1,.9.9,0,0,1-.093.009h-1.5v-.015",
    transform: "translate(-60.12 -105.148)",
    fill: "#600097"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleSchedule);
export default __webpack_public_path__ + "static/media/purpleSchedule.2fbd5124ff54d79664f4b31fbdff0c5b.svg";
export { ForwardRef as ReactComponent };